import React from 'react';
import PropTypes from 'prop-types';
import StatusIcon from './StatusIcon';

const propTypes = {
    items: PropTypes.array
};

function StatusBar(props) {
    const icons = props.items.map(item => {
        return (
            <StatusIcon key={item.id} label={item.label} icon={item.icon} status={item.status} />
        );
    });

    return <div className="mfa-status-bar">{icons}</div>;
}

StatusBar.propTypes = propTypes;

export default StatusBar;
